<template>
  <div id="app">
    <b-row class="search-bar" id="top-row">
      <b-col>
        <div class="logo_img" @click="logoClick">
          <h1>
            <router-link id="router" :to="{ name: 'index' }" tag="div" title="杭州电子科技大学智能媒体计算研究所"> </router-link>
          </h1>
        </div>
      </b-col>
      <b-col>
        <div class="search">
          <div class="search_items">
            <el-input v-model="searchVal" placeholder="请输入关键字" class="search_input" size="small"> </el-input>
            <el-button type="goon" icon="el-icon-search" size="small" @click="handleSearch">搜索 </el-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <div class="header">
            <div class="header-nav">
                <el-menu :default-active="onRoutes" class="el-menu-demo" menu-trigger="click" mode="horizontal"
                    text-color="#fff" background-color="#002d71" active-text-color="#FBC52C" router>
                    <el-menu-item :index="'index'" class="header-title">首页</el-menu-item>
                    <el-menu-item :index="'team'" class="header-title">研究团队</el-menu-item>
                    <el-menu-item :index="'paper'" class="header-title">论文发表</el-menu-item>
                    <el-menu-item :index="'project'" class="header-title">研究项目</el-menu-item>
                    <el-menu-item :index="'newsList'" class="header-title">公告</el-menu-item>
                    <el-menu-item :index="'recruit'" class="header-title">人才管理</el-menu-item>
                    <el-menu-item :index="'contact'" class="header-title">联系我们</el-menu-item>
                </el-menu>
            </div>
        </div> -->
    <b-navbar type="dark" variant="#002d71" toggleable="xl" class="el-menu-demo-2 header-nav header">
      <div id="logo_inMo">
        <router-link id="router-mobile" :to="{ name: 'index' }" tag="div" title="杭州电子科技大学智能媒体计算研究所" @click="logoClick"> </router-link>
      </div>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-row>
            <div class="search_items_mobile" id="search_inMo">
              <el-input v-model="searchVal" placeholder="请输入关键字" class="search_input_mobile" size="small"> </el-input>
              <el-button type="goon" icon="el-icon-search" size="small" @click="handleSearch">搜索 </el-button>
            </div>
          </b-row>
          <b-row class="menu-row">
            <b-col sm="auto">
              <b-nav-item to="/index" exact exact-active-class="active" class="header-title">首页 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item exact exact-active-class="active" class="header-title" to="/newsList"
                >Team Go
                <!-- <div class="dropdown-menu">
                  <b-dropdown-item class="dongTai" to="/newsList">
                    <li class="dongTaiItem">团队动态</li>
                  </b-dropdown-item>
                </div> -->
              </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item exact exact-active-class="active" class="header-title" to="/team"
                >研究团队
                <!-- <div class="dropdown-menu">
                  <b-dropdown-item class="dongTai" to="/team">
                    <li class="dongTaiItem">研究团队</li>
                  </b-dropdown-item>
                  <b-dropdown-item class="dongTai" to="/student">
                    <li class="dongTaiItem">学生</li>
                  </b-dropdown-item>
                </div> -->
              </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item exact exact-active-class="active" class="header-title" to="/student">学生队伍 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item exact exact-active-class="active" class="header-title" to="/achievement"
                >科研成果
                <!-- <div class="dropdown-menu">
                  <b-dropdown-item class="dongTai" to="/project">
                    <li class="dongTaiItem">研究项目</li>
                  </b-dropdown-item>
                  <b-dropdown-item class="dongTai" to="/paper">
                    <li class="dongTaiItem">论文</li>
                  </b-dropdown-item>
                </div> -->
              </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/recruit" exact exact-active-class="active" class="header-title">人才管理 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/contact" exact exact-active-class="active" class="header-title">联系我们 </b-nav-item>
            </b-col>
          </b-row>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!-- <b-navbar type="dark" variant="#002d71" toggleable="xl" class="el-menu-demo-2 header-nav header">
      <div id="logo_inMo">
        <router-link id="router-mobile" :to="{ name: 'index' }" tag="div" title="杭州电子科技大学智能媒体计算研究所" @click="logoClick"> </router-link>
      </div>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-row>
            <div class="search_items_mobile" id="search_inMo">
              <el-input v-model="searchVal" placeholder="请输入关键字" class="search_input_mobile" size="small"> </el-input>
              <el-button type="goon" icon="el-icon-search" size="small" @click="handleSearch">搜索 </el-button>
            </div>
          </b-row>
          <b-row class="menu-row">
            <b-col sm="auto">
              <b-nav-item to="/index" exact exact-active-class="active" class="header-title">首页 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/team" exact exact-active-class="active" class="header-title">研究团队 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/paper" exact exact-active-class="active" class="header-title">科研成果 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/project" exact exact-active-class="active" class="header-title">研究项目 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/newsList" exact exact-active-class="active" class="header-title">信息滚动 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/student" exact exact-active-class="active" class="header-title">学生团队 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/recruit" exact exact-active-class="active" class="header-title">人才管理 </b-nav-item>
            </b-col>
            <b-col sm="auto">
              <b-nav-item to="/contact" exact exact-active-class="active" class="header-title">联系我们 </b-nav-item>
            </b-col>
          </b-row>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar> -->

    <!-- <b-navbar type="light" variant="#002d71" class="el-menu-demo-2 header-nav header">
            <b-container fluid>
                <b-row>
                    <b-col sm="auto">
                        <b-nav-item to="/index" exact exact-active-class="active" class="header-title">首页</b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/team" exact exact-active-class="active" class="header-title">研究团队</b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/paper" exact exact-active-class="active" class="header-title">论文发表</b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/project" exact exact-active-class="active" class="header-title">研究项目
                        </b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/newList" exact exact-active-class="active" class="header-title">公告</b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/recruit" exact exact-active-class="active" class="header-title">人才管理
                        </b-nav-item>
                    </b-col>
                    <b-col sm="auto">
                        <b-nav-item to="/contact" exact exact-active-class="active" class="header-title">联系我们
                        </b-nav-item>
                    </b-col>

                </b-row>
            </b-container>
        </b-navbar> -->

    <div class="container" style="clear: both">
      <keep-alive>
        <router-view v-if="$route.meta.KeepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.KeepAlive"></router-view>
    </div>

    <div class="footer">
      <b-row>
        <b-col>
          <div style="text-align: center">
            <p class="footer_font">邮箱：guodaozhang@hdu.edu.cn</p>
            <div style="margin: auto" class="footer_font">互联网ICP备案</div>
            <div style="margin: auto" class="footer_font">杭州电子科技大学智能媒体计算研究所</div>
          </div>
        </b-col>
        <b-col>
          <div style="text-align: center">
            <div>
              <img :src="company.qrcode" style="border: 0" width="200px" />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
      <p style="font-size: 0.625em; font-weight: bold">TOP</p>
      <img src="../assets/launch.png" style="height: 45px; width: 35px" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      dropdownShow: false,
      company: {
        qrcode: require("@/assets/tip.png"),
      },
      scroll: "",
      timer: "",
      searchVal: "",
    };
  },
  methods: {
    showDropdown() {
      this.dropdownShow = true;
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.$refs.btn.style.display = "block";
      } else {
        this.$refs.btn.style.display = "none";
      }
    },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    logoClick() {
      this.$router.push({
        name: "index",
      });
    },
    handleSearch() {
      this.$router.push({
        name: "newsList",
        query: {
          name: this.searchVal,
        },
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
};
</script>

<style scoped>
.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%; /* Position the dropdown below the parent */
  left: 50;
  background-color: #002d71; /* Customize as needed */
  --bs-dropdown-link-hover-bg: #002d71;
}

.header-title:hover .dropdown-menu {
  display: block;
}

.dongTaiItem {
  color: rgba(255, 255, 255, 0.7);
}
.dongTai {
  cursor: pointer;
  color: rgba(red, green, blue, 0.7);
  background-color: #002d71;
}
.dongTaiItem:hover {
  color: white;
}

@media (max-width: 769px) {
  /* 媒体查询：页面宽度小于等于768px时生效 */
  #nav-collapse {
    overflow-x: auto;
    /* 水平滚动 */
    white-space: nowrap;
    /* 不换行 */
    z-index: 9999;
    background-color: #002d71;
  }

  #top-row {
    display: none;
  }

  .navbar-nav {
    flex-wrap: nowrap;
    /* 不换行 */
    background-color: #002d71;
  }

  .search_items_mobile {
    width: 90%;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
    text-align: center;
  }

  .search_input_monile {
    width: 50%;
  }

  .logo_img_mobile {
    cursor: pointer;
  }

  #logo_inMo {
    display: flex;
    position: relative;
    width: 80%;
    height: 100%;
  }

  #router-mobile {
    background: url(~@/assets/logo-04.svg) no-repeat;
    display: inline-block;
    background-size: 100%;
    width: 50%;
    height: 100%;
    background-position: center;
    text-indent: -9999px;
    overflow: hidden;
  }
}

@media (min-width: 769px) {
  #logo_inMo {
    display: none;
  }

  #search_inMo {
    display: none;
  }

  #nav-collapse {
    background-color: #002d71;
    padding-left: 2%;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

h1 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

.search_input {
  width: 50%;
}

.search-bar {
  height: 8rem;
  margin-right: 0;
}

.row {
  margin-right: 0 !important;
}

.search {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;
  margin: 3rem auto;
}

.search_items {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

#router {
  background: url(~@/assets/logo-04.svg) no-repeat;
  display: inline-block;
  background-size: 60%;
  width: 100%;
  height: 100%;
  background-position: center;
  text-indent: -9999px;
  overflow: hidden;
}

.logo_img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 5px auto;
}

#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
}

.header-title {
  position: relative;
  display: inline;
  font-size: 1em;
  color: #fff;
}

.footer_font {
  font-size: 1em;
}

.el-menu-demo {
  border: 0;
  text-align: center;
}

.el-menu-demo-2 {
  border: 0;
  text-align: center;
  margin: auto;
}

.header-nav {
  margin: 0 auto;
  width: 80%;
}

.header {
  margin: 5px auto;
  width: 100%;
  height: 65px;
  background: #002d71;
  z-index: 9999;
}

.footer {
  width: 100%;
  background-color: #002d71;
  margin-top: 20px;
  color: #fff;
  padding: 20px 0px;
}

/* 网页中使用 */
.el-row {
  margin: 0 !important;
}

/* 修改按钮颜色 */

.el-button--goon.is-active,
.el-button--goon:active {
  background: #002d71;
  border-color: #002d71;
  color: #fff;
}

.el-button--goon:focus,
.el-button--goon:hover {
  background: #043d92;
  border-color: #043d92;
  color: #fff;
}

.el-button--goon {
  color: #fff;
  background-color: #002d71;
  border-color: #002d71;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
